// ButtonLoader.js
import React from "react";
import "./ButtonLoader.scss";

const ButtonLoader = ({ text, bgColor, icon, textColor }) => {
  return (
    <button className="LoadingButton"  
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      {icon && <span className="button-icon">{icon}</span>}
      {text && <span className="button-text">{text}</span>}
      <span className="loading-dots">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </span>
    </button>
  );
};

export default ButtonLoader;
